// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"06530467","257":"8a058bec"}[chunkId] + ".chunk.css";
};